import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useCountdown } from "../../hooks";
// 숫자를 2자리 문자열로 변환
const formatTime = (value)=>String(value).padStart(2, "0");
// 시간 단위 컴포넌트
const TimeUnit = (param)=>/*#__PURE__*/ {
    let { value , unit  } = param;
    return _jsxs("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                className: "sm:typo-subtitle1 tabular-nums",
                children: formatTime(value)
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                className: "sm:typo-subtitle1",
                children: unit
            })
        ]
    });
};
// 공통 컨테이너 스타일
const containerStyles = (isUsed, className)=>cn("flex flex-col sm:flex-row sm:items-center sm:justify-between w-full", "p-4 sm:px-5 sm:py-4 rounded-md", "gap-4 sm:gap-0", isUsed ? "bg-gray-50" : "bg-mint-0 border border-mint-400", className);
// CTA 버튼 컴포넌트
const CtaButton = (param)=>/*#__PURE__*/ {
    let { onClick  } = param;
    return _jsx(Button, {
        variant: "fill",
        color: "primary",
        size: "sm",
        onClick: onClick,
        className: "w-full sm:w-auto",
        children: "즉시 무제한 이용하기"
    });
};
/**
 * 카테고리 페이지용 무료체험 모듈
 */ export const FreeTrialModule = (param)=>{
    let { className , remainingCount =1 , totalCount =1 , endTime , purchaseUrl , promotionId , promotionTitle , onCtaClick , onTimeUp  } = param;
    const router = useRouter();
    const isUsed = remainingCount === 0;
    const { hours , minutes , seconds  } = useCountdown(undefined, onTimeUp);
    const isSoon = !isUsed && hours === 0;
    // MX-355: CTA 클릭 핸들러: purchaseUrl이 있으면 이동, 없으면 onCtaClick 호출
    const handleCtaClick = ()=>{
        mixpanelEvent("Free Trial Promotion CTA Button", {
            "Button URL": purchaseUrl || "",
            "Free Trial Promotion Id": promotionId || "",
            "Free Trial Promotion Title": promotionTitle || ""
        });
        if (purchaseUrl) {
            router.push(purchaseUrl);
        } else {
            onCtaClick === null || onCtaClick === void 0 ? void 0 : onCtaClick();
        }
    };
    // 무료 혜택을 모두 사용한 경우
    if (isUsed) {
        return /*#__PURE__*/ _jsxs("div", {
            className: containerStyles(true, className),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle2",
                    className: "text-secondary sm:typo-subtitle1 text-center sm:text-left",
                    children: "무료 혜택을 모두 사용했어요."
                }),
                /*#__PURE__*/ _jsx(CtaButton, {
                    onClick: handleCtaClick
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: containerStyles(false, className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-8",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "text-mint-500 sm:typo-subtitle1 whitespace-nowrap",
                                children: "무료혜택 남은 시간"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: cn("flex items-center gap-1 text-center", isSoon ? "text-status-error" : "text-strong"),
                                children: [
                                    hours > 0 && /*#__PURE__*/ _jsx(TimeUnit, {
                                        value: hours,
                                        unit: "시간"
                                    }),
                                    /*#__PURE__*/ _jsx(TimeUnit, {
                                        value: minutes,
                                        unit: "분"
                                    }),
                                    /*#__PURE__*/ _jsx(TimeUnit, {
                                        value: seconds,
                                        unit: "초"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "text-mint-500 sm:typo-subtitle1 whitespace-nowrap",
                                children: "무료혜택 남은 횟수"
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "subtitle2",
                                className: "text-strong sm:typo-subtitle1",
                                children: [
                                    remainingCount,
                                    "/",
                                    totalCount,
                                    "회"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CtaButton, {
                onClick: handleCtaClick
            })
        ]
    });
};
